<template>
  <div class="isTxt" v-show="isTxt">
    {{ name || '-' }}
  </div>
  <MemberMultipleSelection
    v-show="!isTxt"
    :paramsData="commonParams"
    :api="getPageComponentData"
    :disabled="isTxt || renderConfig.disabled"
    :placeholder="renderConfig.placeholder"
    :showValueData="showValueData"
    @sure="getUser"
    @getUserList="getUserList"
    style="width: 100%"
  />
</template>

<script lang="ts" setup>
import { useNavHistory } from '@/stores/modules/routerNav'
import { computed, ref, onMounted, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { getPageComponentData } from '@/apis/customerManage'
import { isArray, isNullOrUndefOrEmpty, isEmptyArray } from '@/utils/is'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { getPersonAnyDepDefaultValue } from '@/utils/render/defaultValue'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const emit = defineEmits(['update:modelValue', 'refreshDataList', 'updadeViewData'])
const navHistory = useNavHistory()
// console.log(navHistory, 'navHistory')
const systemCode = navHistory.activeSysCode
const load = ref<boolean>(true)

const props = defineProps({
  ...basicProps,
  // 使用场景类型
  sceneType: {
    type: Number,
    default: 0
  },
  // 主表数据
  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  }
})
// console.log(props, 'aaaaaaaaaaaa')
const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    if (isNullOrUndefOrEmpty(newVal) || isEmptyArray(newVal)) {
      getName([])
    }
    emit('update:modelValue', newVal)
  }
})
let name = ref('')
function getName(list: any) {
  const arr: string[] = []
  list.forEach(item => {
    arr.push(item.realName)
  })
  name.value = arr.length ? arr.join(',') : '-'
}

const showValueData = computed(() => {
  let value: Recordable[] = []
  if (innerValue.value) {
    if (!isArray(innerValue.value)) {
      value = innerValue.value.split(',').map((item: Recordable) => ({ id: item }))
    } else {
      value = innerValue.value?.map((item: Recordable) => ({ id: item }))
    }
  }
  return value
})

const commonParams = {
  columnId: props.data.id,
  columnUseScene: props.data.columnUseScene,
  tableCode: props.data.tableCode,
  extraAgreements: {
    systemCode: systemCode,
    containChildren: 1,
    useSceneType: props.data.useSceneType,
    disableUserIds: !isArray(innerValue.value) ? innerValue.value.split(',') : innerValue.value
  }
}

function getUser(data: Recordable) {
  emit('refreshDataList', data.userInfoList)
  innerValue.value = data.userInfoList.map((item: Recordable) => item.id)
}

function getUserList(data: Recordable) {
  console.log(data, 'data444')
  if (!isNullOrUndefOrEmpty(data)) {
    getName(data)
    emit('refreshDataList', data)
    emit('updadeViewData', innerValue.value)
  }
}

watch(
  () => props.isTxt,
  val => {
    if (!val && props.modelValue === '') {
      emit('update:modelValue', getPersonAnyDepDefaultValue(props) || '')
    }
  },
  { immediate: true }
)

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>

<style lang="scss" scoped></style>
